import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import Chip from '@mui/material/Chip';
import { Story, StoryStatus } from '../types';
import { useStringsContext } from '../../../../contexts/strings';

interface Props {
  selectedStory: Story;
  status: StoryStatus | null;
}

const StoryTitle = ({ selectedStory, status }: Props) => {
  const { strings } = useStringsContext();

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Stack>
        <Typography variant="h5">{selectedStory.caption}</Typography>
        <Typography variant="body2">
          {`Skapad ${moment(selectedStory.createdAt).format('YYYY-MM-DD HH:mm')}`}
        </Typography>
      </Stack>
      {status === 'PUBLISHED' && <Chip label={strings.stories.statusPublished} color="success" />}
      {status === 'SCHEDULED' && <Chip label={strings.stories.statusScheduled} color="warning" />}
    </Stack>
  );
};

export default StoryTitle;
